import React, { lazy, Suspense } from 'react';

const Loading = lazy(() => import('pages/SSO/animations/Loading'));

interface Props {
  height: string;
  width: string;
}

export const LoadSpin = ({ height, width }: Props) => {
  return (
    <Suspense fallback={<></>}>
      <div style={{ height, textAlign: 'center' }}>
        <Loading height={height} width={width} />
      </div>
    </Suspense>
  );
};
